<div class="btr-section-title">
    <span class="btr-section-title__step" aria-hidden="true">{{ step }}</span>
    <ds-text [id]="headingId" role="heading" aria-level="3" size="md" weight="semibold" [color]="titleColor" [text]="text"></ds-text>
</div>
